import { useQuery } from "@tanstack/react-query";
import { getBrokerAccounts } from "services";

export const brokerAccountsQueryKey = (strategyId) => [
  "brokerAccounts",
  strategyId,
];

export const useBrokerAccounts = (strategyId, onSuccess, onError) => {
  return useQuery({
    queryKey: brokerAccountsQueryKey(strategyId),
    queryFn: () => getBrokerAccounts(strategyId),
    enabled: !!strategyId,
    onSuccess,
    onError,
  });
};
